module.exports = __webpack_public_path__ + "img/sand-dune-decal-26.a547be5f.png";